var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DetailTemplate',{attrs:{"activeIndexNum":_vm.activeIndex,"showSublings":false,"showRelated":false,"map":true}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78aca26c","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/link/jingdian.vue
// module id = 1442
// module chunks = 0